import { LanguagesService } from '@alpha-core/platform-ui';
import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlphaSharedModule } from '../../shared/alpha-shared.module';

@Component({
    selector: 'app-pagination-bar',
    standalone: true,
    imports: [AlphaSharedModule],
    templateUrl: './pagination-bar.component.html',
})
export class PaginationBarComponent {
    private languageService = inject(LanguagesService);

    dropdownIconClass = 'pi pi-chevron-down';
    pageSizeOptions: Array<{ value: number; viewValue: string }> = [
        { value: 5, viewValue: '5 Rows' },
        { value: 10, viewValue: '10 Rows' },
        { value: 25, viewValue: '25 Rows' },
        { value: 50, viewValue: '50 Rows' },
    ];

    @Input() filters!: {
        pageSize: number;
        page: number;
        totalCount: number;
        searchKey: string;
    };
    @Output() filtersChange: EventEmitter<any> = new EventEmitter();
    @Output() pageSizeChange: EventEmitter<any> = new EventEmitter();
    @Output() filtersSearch: EventEmitter<any> = new EventEmitter();

    destroyRef = inject(DestroyRef);
    searchKey: any;

    ngOnInit() {
        this.languageService.selectedLanguage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((language) => {
            if (language) {
                this.getPageSizeOpts();
            }
        });
        this.getPageSizeOpts();
    }

    onDropdownOpen() {
        this.dropdownIconClass = 'pi pi-chevron-up';
    }
    onDropdownClose() {
        this.dropdownIconClass = 'pi pi-chevron-down';
    }

    getPageSizeOpts() {
        const rowTranslation = this.languageService.getTranslation('default-cm-rows') || 'Rows';
        this.pageSizeOptions = this.pageSizeOptions.map((opts) => ({
            ...opts,
            viewValue: `${opts.value} ${rowTranslation}`,
        }));
    }

    changePage(changeType: 'increment' | 'decrement') {
        if (changeType == 'increment') this.filters.page++;
        else this.filters.page--;
        this.filtersChange.emit(this.filters);
    }

    onKeywordChange(event?: any): void {
        this.filtersSearch.emit(this.filters);
    }
}
